import React from 'react';
import './about.css';
function About(){

    
    return(
        
      <div className='about_container'>
            <div className='about_title'>About</div>
            <div className='about_descr'>TweetsMark allows the selection of preferred tweets from your Twitter field that help to consume curated information easier. We are here to help you in this busy world where you are overwhelmed with all the information and you don't want to miss out anything important. Now that we are here as your ultimate time saver on twitter, help yourself gain a productivity boost.<b> With us, go grab the world!</b></div>
            
            
        </div>
      

    
    );
}
export default About;